import SurgeryConfig from "@/views/configs/surgery/index.vue";
import SurgeryMaterialConfig from "@/views/configs/surgery/material.vue";
import SurgerySurgeriesConfig from "@/views/configs/surgery/surgery.vue";
import SurgeryDescriptionConfig from "@/views/configs/surgery/surgery_description.vue";
import SurgeryAnesthesiaDescriptionConfig from "@/views/configs/surgery/anesthesia_description.vue";
//import SurgeryIndicationItemConfig from "@/views/configs/surgery/item.vue";

export default [
  {
    path: "cirurgia",
    name: "Config cirurgia",
    component: SurgeryConfig,
    redirect: {
      path: "/configuracoes/cirurgia/materiais",
    },
    children: [
      {
        path: "materiais",
        name: "Config materiais cirurgia",
        component: SurgeryMaterialConfig,
      },
      {
        path: "cirurgias",
        name: "Config cirurgias",
        component: SurgerySurgeriesConfig,
      },
      {
        path: "descricao-cirurgica",
        name: "Config descrição cirurgia",
        component: SurgeryDescriptionConfig,
      },
      {
        path: "descricao-anestesica",
        name: "Config descrição anestésica",
        component: SurgeryAnesthesiaDescriptionConfig,
      },
    ],
  },
];
